<template>
  <div id="topNav">
    <b-navbar toggleable="lg" :class="access_token ? 'py-0' : 'py-3'">
      <!-- Mobile Side Menu -->
      <b-navbar-nav id="sideMenuMobile" v-show="!showSearch">
        <sideMenuMobile />
      </b-navbar-nav>

      <!-- Logo -->
      <b-navbar-brand id="logo" class="navbar-brand col-1 d-flex justify-content-center align-items-center py-3 py-lg-0"
        v-show="!showSearch" href="/">
        <img :src="logo" style="height: 100%; max-height: 60px; width: auto;" alt="E-learning" />
        
      </b-navbar-brand>


      <!-- Desktop Search -->
      <b-navbar-nav v-if="$router.currentRoute.name == 'Home'" id="searchLg" class="pl-0" v-show="!showSearch">
        <Search @search="searchCouse" />
      </b-navbar-nav>

      <!-- Sidebar Toggle -->
      <b-navbar-toggle target="nav_sidebar" v-b-toggle.nav_sidebar>
        <b-icon-list variant="dark"></b-icon-list>
      </b-navbar-toggle>

      <!-- Desktop Auth Buttons -->
      <b-navbar-nav class="ml-auto" id="navBtn_desktopSide" v-show="!isMobile" >
        <template v-if="access_token" >
          <b-nav-item-dropdown right menu-class="no-padding-left">
            <template #button-content>
              <UserPanel :image="userdata.profile_image" :department="userdata.department"
                :name="`${userdata.first_name} ${userdata.last_name}`" :id="userdata.id" />
            </template>
            <b-dropdown-item  @click="goto('userProfile')">โปรไฟล์</b-dropdown-item>
            <b-dropdown-item @click="logout">ออกจากระบบ</b-dropdown-item>
          </b-nav-item-dropdown>
        </template>
        <template v-else class="py-2">
          <b-button class="btn  mx-1 " style="background-color: white; color: #00264E; border: none;"
            href="/login">เข้าสู่ระบบ</b-button>
          <b-button class="btn btnmain  mx-1  " href="/register">ลงทะเบียน</b-button>
        </template>
      </b-navbar-nav>
    </b-navbar>

    <!-- Sidebar Menu -->
    <b-sidebar id="nav_sidebar" style="color: white" right shadow is-nav>
      <b-navbar-nav class="ml-auto">
        <template v-if="access_token">
          <b-nav-item-dropdown right>
            <template #button-content>
              <UserPanel :image="userdata.profile_image" :department="userdata.department"
                :name="`${userdata.first_name} ${userdata.last_name}`" :id="userdata.id" />
            </template>
            <b-dropdown-item @click="goto('userProfile')">โปรไฟล์</b-dropdown-item>
            <b-dropdown-item @click="logout">ออกจากระบบ</b-dropdown-item>
          </b-nav-item-dropdown>
        </template>
        <template v-else>
          <b-button class="btn btn-light mx-1 btnHover btnNav" href="/login">เข้าสู่ระบบ</b-button>
          <b-button class="btn btn-primary mx-1 btnHover btnNav" href="/register">ลงทะเบียน</b-button>
        </template>
      </b-navbar-nav>
    </b-sidebar>

  </div>
</template>

<script>
import logo from "./../../public/logo.png";
import Search from "@/components/search";
import sideMenuMobile from "@/components/sideMenuMobile";
import UserPanel from "@/components/UserPanel";
import { mapState } from "vuex";
import Swal from "sweetalert2"; 

export default {
  name: "topNav",
  components: {
    sideMenuMobile,
    UserPanel,
    Search,
  },
  data() {
    return {
      logo, 
      showSearch: false,
      isMobile: false,
    };
  },
  computed: {
    ...mapState({
      access_token: (state) => state.Auth.access_token,
      userdata: (state) => state.Auth.userData,
    }),
  },
  mounted() {
    this.checkIfMobile();
    window.addEventListener("resize", this.checkIfMobile);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.checkIfMobile);
  },
  methods: {
    logout() {
      this.$store.dispatch("Auth/logout").then((res) => {
        if (res === 200) {
          this.$router.push("/");
          Swal.fire("เรียบร้อย!", "ออกจากระบบเรียบร้อย", "success");
        }
      });
    },
    goto(routeName) {
      this.$router.push({ name: routeName });
    },
    getSearchInput() {
      this.showSearch = true;
    },
    hideSearchInput() {
      this.showSearch = false;
    },
    checkIfMobile() {
      this.isMobile = window.innerWidth <= 991;
    },
    searchCouse(text) {
      this.showSearch = true;
      this.$emit("searchCouse", text);
    },
  },
};
</script>

<style>
#topNav {
  border-bottom: 1px rgba(200, 187, 187, 0.2) solid !important;
  box-shadow: 0 4px 8px 0 rgba(200, 187, 187, 0.2),
    0 6px 20px 0 rgba(174, 168, 168, 0.19);
}

.btnNav {
  background-color: transparent !important;
  border: none !important;
}

#btnGetNavSearch {
  border: none !important;
}

@media screen and (min-width: 991px) {
  #sideMenuMobile {
    display: none !important;
  }

  #btnGetNavSearch {
    display: none !important;
  }
}

@media screen and (max-width: 991px) {
  #searchLg {
    display: none !important;
  }

  #navBtn_desktopSide {
    display: none !important;
  }
} 

.no-padding-left{
  padding-left: 0 !important;
}
</style>
